import { ComponentPropsWithoutRef } from "react";
import * as styles from "./WrapperNavSpacing.css";
import clsx from "clsx";

export type WrapperNavSpacingProps = ComponentPropsWithoutRef<"div"> & {
  noSpacingOnMobile?: boolean;
};

export const WrapperNavSpacing = ({
  noSpacingOnMobile = false,
  className,
  children,
}: WrapperNavSpacingProps) => {
  return (
    <div
      className={clsx(
        className,
        styles.wrapper({ noSpacingOnMobile: noSpacingOnMobile })
      )}
    >
      {children}
    </div>
  );
};
